/**
 * 🤝 顧客 (/customers)
 *
 * v3.3 IA 刷新で「顧客リスト / 個別説明」の Hub として新設。
 * 2026-10-07: 個別説明 (sales.briefings) をサイドバーの独立メニュー (/briefings) へ移したため
 * Hub (タブの帯) をやめ、顧客リストを直接表示する。
 * 旧 URL `/customers?hub=briefings` (ブックマーク等) は /briefings へ転送する。
 */
import { hasPermission } from '@goenhub/shared';
import { Navigate, useSearchParams } from 'react-router-dom';

import { useMyPermissions } from '@/features/permissions';
import { SalesContactsPage } from '@/pages/sales-contacts/SalesContactsPage';
import { paths } from '@/routes/paths';

export function CustomersHubPage() {
  const [searchParams] = useSearchParams();
  const { isOwner, permissions } = useMyPermissions();
  if (searchParams.get('hub') === 'briefings') {
    // 個別説明側のタブ・絞り込み (?tab= &month= 等) は引き継ぐ
    const rest = new URLSearchParams(searchParams);
    rest.delete('hub');
    const qs = rest.toString();
    return <Navigate to={`${paths.briefings}${qs ? `?${qs}` : ''}`} replace />;
  }
  if (!hasPermission({ isOwner, permissions, featureId: 'sales.contacts', action: 'view' })) {
    return (
      <div className="text-sm text-[var(--text-muted)] p-8 text-center">
        このセクションへのアクセス権限がありません。
      </div>
    );
  }
  return <SalesContactsPage />;
}
